import { useEffect, useState } from "react";
import { http, formatErr } from "../../lib/api";
import { usePolling } from "../../lib/usePolling";
import { toast } from "sonner";
import { CheckCircle2, XCircle } from "lucide-react";

export default function CrmModalita() {
  const [list, setList] = useState([]);
  const [rej, setRej] = useState({});

  const load = async () => { try { const { data } = await http.get("/crm/mode-changes", { params: { status: "da_approvare" } }); setList(data); } catch (e) { toast.error(formatErr(e)); } };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);
  usePolling(load, { interval: 10000, enabled: true });

  const approve = async (id) => { try { await http.post(`/crm/mode-changes/${id}/approve`); await load(); toast.success("Cambio approvato (nuova decorrenza; vendite pregresse invariate)."); } catch (e) { toast.error(formatErr(e)); } };
  const reject = async (id) => { if (!(rej[id] || "").trim()) return toast.error("Motivazione richiesta."); try { await http.post(`/crm/mode-changes/${id}/reject`, { reason: rej[id] }); await load(); } catch (e) { toast.error(formatErr(e)); } };

  return (
    <div data-testid="crm-modalita-page" className="max-w-3xl mx-auto">
      <h1 className="font-serif text-3xl mb-4">Cambio modalità provvigionale</h1>
      <div className="space-y-3" data-testid="crm-modalita-list">
        {list.length === 0 && <div className="card-clean p-6 text-sm text-neutral-500">Nessuna richiesta in attesa.</div>}
        {list.map((m) => (
          <div key={m.id} className="card-clean p-4" data-testid={`crm-modalita-${m.id}`}>
            <div className="flex items-center gap-3 flex-wrap">
              <div className="flex-1 text-sm">Agente {m.agent_id?.slice(0, 8)} · da <strong>{m.from_mode}</strong> → <strong>{m.to_mode}</strong>{m.note ? ` · ${m.note}` : ""}</div>
              <button onClick={() => approve(m.id)} data-testid={`cm-approve-${m.id}`} className="px-3 py-1.5 rounded-md text-white text-xs flex items-center gap-1" style={{ background: "var(--brand-dark)" }}><CheckCircle2 className="w-3 h-3" /> Approva</button>
            </div>
            <div className="flex gap-2 mt-2">
              <input placeholder="Motivazione rifiuto" value={rej[m.id] || ""} onChange={(e) => setRej((s) => ({ ...s, [m.id]: e.target.value }))} data-testid={`cm-reason-${m.id}`} className="flex-1 px-3 py-1.5 rounded-md border text-xs" style={{ borderColor: "var(--border-silver)" }} />
              <button onClick={() => reject(m.id)} data-testid={`cm-reject-${m.id}`} className="px-3 py-1.5 rounded-md border text-xs flex items-center gap-1 text-rose-600" style={{ borderColor: "var(--border-silver)" }}><XCircle className="w-3 h-3" /> Rifiuta</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
